import { clearCell, getTxtByRange, setCellValue } from "../global/api";
import Store from "../store";
import imageCtrl from "./imageCtrl";
import { checkProtectionAuthorityNormal } from "./protection";
import sheetmanage from "./sheetmanage";

export const cellImageCtrl = {
	// 定义内部自己的图片缓存
	imageCache: new Set(),

	/**
	 * @description 添加单元格图片 - 在 imgCtrl 中调用，主要是修改 imgItem inCell 属性 及设置单元格公式
	 * @param {*} imgItem
	 * @param {*} id
	 * @returns
	 */
	addCellImage: function (imgItem, id) {
		if (!imgItem) return;

		// 1. 获取当前用户选区
		let { column, row } = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];

		// 2. 只取第一个单元格，绘制时再判断是否为合并单元格
		//  *  1. getRangeAxis 获取选区文本 直接返回 A2:F4
		//  *  2. getTxtByRange 将 range 转成文本 需要传入 range = { row:[1,2],comlumn:[1,2] }
		const range = { row: [row[0], row[0]], column: [column[0], column[0]] };
		const rangeText = getTxtByRange(range);

		// 3. 修改 imgItem 为单元格图片
		imgItem.inCell = rangeText;

		// 4. 生成公式
		const formula = `=DISPIMG('${id}',1)`; // 1 表示填充单元格 2 表示保持宽高比

		// 5. 将公式写入单元格
		clearCell(row[0], column[0]);
		setCellValue(row[0], column[0], formula);
	},

	/**
	 * @description 为图片上传定义 input
	 */
	imageUpload: function (menuValue) {
		// 任何类型的图片，都需要执行 input file 选择图片文件 ,
		// 后续执行 imageCtrl 的方法时，可区分图片类型，同时 如果是单元格图片，则需要处理 单元格 公式 = DISPIMG('url')

		// 1. 创建 input
		const $input = $(`<input type="file" accept="image/*" style="display:none" />`);

		// 2. 添加到 body
		$("body").append($input);

		// 3. 绑定 change 事件
		$input.on("change", function (e) {
			if (!checkProtectionAuthorityNormal(Store.currentSheetIndex, "editObjects", false)) {
				return;
			}

			// 判断是否选中图片类型
			if (e.currentTarget.files == null || e.currentTarget.files.length == 0) {
				return;
			}

			const file = e.currentTarget.files[0];

			if (file.type.indexOf("image/") !== 0) {
				tooltip.info("仅支持图片文件", "");
				return;
			}

			// 执行插入,并将图片类型传递过去
			imageCtrl.insertImg(file, menuValue);

			// 移除 input
			$input.remove();
		});

		// 4. 触发 input
		$input.click();
	},

	/**
	 * @description 单元格图片转换为浮动图片
	 */
	inCellImageToFloatImage: function () {
		// 1. 获取当前选中的单元格
		// 1. 获取当前用户选区
		let { column, row } = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];

		const r = row[0];
		const c = column[0];

		const cell = Store.flowdata[r][c];

		// 2. 如果当前单元格不是 f = ‘DISPIMG’ 则不处理
		if (!cell || !cell.f || !cell.f.startsWith("=DISPIMG")) return;

		// 3. 修改 imgItem incell 属性，并重新执行 addImage
		// 获取图片ID
		const { imgID } = this.getImageIDAndMode(cell.f);

		// 修改属性不能取 sheetFile 对象，应该取 imgCtrl 数据
		const imageList = imageCtrl.images;

		const imageItem = imageList[imgID];

		if (!imageItem) return;

		imageItem.inCell = "";

		// 重新更新数据
		imageCtrl.ref();

		// 重新渲染图片
		imageCtrl.allImagesShow();

		// 4. 清空当前单元格公式即可
		clearCell(r, c);
	},

	/**
	 * @description 浮动图片转换为单元格图片
	 */
	floatImageToInCellImage: function (imgID) {
		if (!imgID) return;

		// 修改属性不能取 sheetFile 对象，应该取 imgCtrl 数据
		const imageList = imageCtrl.images;

		const imageItem = imageList[imgID];

		if (!imageItem) return;

		// 获取当前选区
		// 1. 获取当前用户选区
		let { column, row } = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];

		// 2. 只取第一个单元格，绘制时再判断是否为合并单元格
		//  *  1. getRangeAxis 获取选区文本 直接返回 A2:F4
		//  *  2. getTxtByRange 将 range 转成文本 需要传入 range = { row:[1,2],comlumn:[1,2] }
		const range = { row: [row[0], row[0]], column: [column[0], column[0]] };
		const rangeText = getTxtByRange(range);

		// 3. 修改 imageItem 为单元格图片
		imageItem.inCell = rangeText;

		// 重新更新数据
		imageCtrl.ref();

		// 重新渲染图片
		imageCtrl.allImagesShow();

		// 设置公式
		const r = row[0];
		const c = column[0];

		// 4. 生成公式
		const formula = `=DISPIMG('${imgID}',1)`; // 1 表示填充单元格 2 表示保持宽高比

		// 5. 将公式写入单元格
		clearCell(r, c);
		setCellValue(r, c, formula);
	},

	/**
	 * @description 单元格图片的预览
	 */
	previewCellImage: function (r, c) {
		const cell = Store.flowdata[r][c];

		if (!cell) return false;

		// 获取图片参数
		const { imgID, mode } = this.getImageIDAndMode(cell.f);

		// 获取图片 src
		let sheetFile = sheetmanage.getSheetByIndex();

		const imageList = sheetFile?.images || [];

		const imageItem = imageList[imgID];

		if (!imageItem) return;

		const { src } = imageItem;

		const imageSrc = this.getImageSrc(src);

		// 创建预览模态框
		this.createPreviewModal(imageSrc, imgID);
	},

	/**
	 * @description 创建图片预览模态框
	 * @param {String} src 图片路径
	 * @param {String} imgID 图片ID
	 */
	createPreviewModal: function (src, imgID) {
		// 移除已存在的预览模态框
		$("#luckysheet-modal-dialog-cell-image-preview").remove();

		// 创建模态框HTML
		const modalHtml = `
			<div id="luckysheet-modal-dialog-cell-image-preview" class="luckysheet-modal-dialog luckysheet-modal-dialog-cell-image-preview">
				<div class="luckysheet-modal-dialog-title">
					<span>图片预览</span>
					<span class="luckysheet-modal-dialog-title-close">
						<i class="fa fa-times" aria-hidden="true"></i>
					</span>
				</div>
				<div class="luckysheet-modal-dialog-content">
					<div class="image-container">
						<img src="${src}" alt="预览图片" />
					</div>
				</div>
			</div>
		`;

		// 添加到页面中
		$("body").append(modalHtml);

		// 显示遮罩层
		$("#luckysheet-modal-dialog-mask").show();

		// 定位模态框
		const $modal = $("#luckysheet-modal-dialog-cell-image-preview");
		const modalWidth = $modal.outerWidth();
		const modalHeight = $modal.outerHeight();
		const winWidth = $(window).width();
		const winHeight = $(window).height();
		const scrollLeft = $(document).scrollLeft();
		const scrollTop = $(document).scrollTop();

		$modal
			.css({
				left: (winWidth + scrollLeft - modalWidth) / 2,
				top: (winHeight + scrollTop - modalHeight) / 2,
			})
			.show();

		// 等待模态框完全显示后再添加水印
		setTimeout(() => {
			const $imageContainer = $modal.find(".image-container");
			const $img = $imageContainer.find("img");

			// 使用.one()确保事件只触发一次，避免重复触发问题
			$img.one("load", () => {
				// 创建canvas元素用于绘制水印
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d");

				const imgWidth = $img.width();
				const imgHeight = $img.height();

				// 设置canvas尺寸
				canvas.width = imgWidth;
				canvas.height = imgHeight;

				// 绘制图片
				const imgElement = $img.get(0);
				ctx.drawImage(imgElement, 0, 0, imgWidth, imgHeight);

				// 绘制水印
				this.drawWatermark(ctx, imgWidth, imgHeight);

				// 替换图片为带水印的图片
				$img.attr("src", canvas.toDataURL("image/png"));
			});

			// 如果图片已经加载完成
			if ($img.get(0).complete) $img.trigger("load");
		}, 10);

		// 绑定关闭事件
		$modal.find(".luckysheet-modal-dialog-title-close").on("click", function () {
			$("#luckysheet-modal-dialog-cell-image-preview").remove();
			$("#luckysheet-modal-dialog-mask").hide();
		});

		// 点击遮罩层关闭
		$("#luckysheet-modal-dialog-mask")
			.off("click.cellImagePreview")
			.on("click.cellImagePreview", function () {
				$("#luckysheet-modal-dialog-cell-image-preview").remove();
				$("#luckysheet-modal-dialog-mask").hide();
				$(this).off("click.cellImagePreview");
			});
	},

	/**
	 * @description 传入一个 r c 判断传入单元格是否为单元格图片，cell.v.f.includes('=DISPIMG') 返回 true/false
	 */
	isCellImage(r, c) {
		const cell = Store.flowdata[r][c];

		if (!cell || !cell.f) return false;

		return cell.f.includes("=DISPIMG");
	},

	/**
	 * @description 辅助函数 - 传入 f 解析图片ID及显示模式
	 * @param {Object} cell 单元格对象
	 */
	getImageIDAndMode(f) {
		let imgID = "",
			mode = "";
		// =DISPIMG('img_wx5a6n0A1ael_1600925814407',2)
		// 匹配DISPIMG函数的正则表达式
		const dispImgRegex = /=*DISPIMG\(['"]([^'"]+)['"],(\d+)\)/;
		const match = f.match(dispImgRegex);
		if (match) {
			imgID = match[1]; // 图片ID: img_wx5a6n0A1ael_1600925814407
			mode = match[2]; // 显示模式: 2
		}

		return { imgID, mode };
	},

	/**
	 * @description 绘制单元格图片
	 * @param {Object} ctx canvas上下文
	 */
	luckysheetDrawCellImage(canvas, item, imgID, mode, scrollWidth, scrollHeight, drawWidth, drawHeight, offsetLeft, offsetTop) {
		// 通过图片ID 获取图片地址
		if (Store.flowdata == null) {
			return;
		}

		//参数未定义处理
		if (scrollWidth == null) {
			scrollWidth = $("#luckysheet-cell-main").scrollLeft();
		}
		if (scrollHeight == null) {
			scrollHeight = $("#luckysheet-cell-main").scrollTop();
		}

		if (drawWidth == null) {
			drawWidth = Store.luckysheetTableContentHW[0];
		}
		if (drawHeight == null) {
			drawHeight = Store.luckysheetTableContentHW[1];
		}

		if (offsetLeft == null) {
			offsetLeft = Store.rowHeaderWidth;
		}
		if (offsetTop == null) {
			offsetTop = Store.columnHeaderHeight;
		}

		let sheetFile = sheetmanage.getSheetByIndex();

		const imageList = sheetFile?.images || [];

		const imageItem = imageList[imgID];

		if (!imageItem) return;

		const { src } = imageItem;

		// 创建图片缓存对象
		if (!this.imageCache) {
			this.imageCache = new Set();
		}

		// 如果图片已经缓存并且加载完成，直接绘制
		// 需要添加 complete 属性，避免刷新异常
		if (this.imageCache[imgID] && this.imageCache[imgID].complete) {
			this.drawImageToCanvas(canvas, this.imageCache[imgID], item, offsetLeft, offsetTop);
			return;
		}

		// 创建新的图片对象并缓存
		const image = new Image();
		image.src = this.getImageSrc(src);
		this.imageCache[imgID] = image;

		image.onload = () => {
			canvas.save();
			canvas.scale(Store.devicePixelRatio, Store.devicePixelRatio);
			this.drawImageToCanvas(canvas, image, item, offsetLeft, offsetTop);
			canvas.restore();
		};

		// 处理加载错误的情况
		image.onerror = () => {
			console.warn("图片加载失败:", src);
			// 绘制一个占位符
			this.drawPlaceholder(canvas, item, offsetLeft, offsetTop);
		};
	},

	/**
	 * @description 粘贴图片处理函数 - 需要进行粘贴处理，如果多张图片公用一个imgID，会导致删除时，相同ID的图片都删除
	 */
	pasteCellImageHandler(f) {
		// 这个函数直接调用的是 selection.pasteHandlerOfCopyPaste，是通过 if (value != null && value.f != null) 来判断的，如果不是 DISPIMG 则应该直接返回 f，不然需要处理图片 ID
		if (!f) return f;
		if (!f.includes("=DISPIMG")) return f;

		// Step 1: 解析当前公式的 f 中的 ID，因为要复制图片资源
		const { imgID } = this.getImageIDAndMode(f);

		// Step 2: 生成一个图片ID
		const newImgId = imageCtrl.generateRandomId();

		// Step 3: 替换图片ID
		f = f.replace(imgID, newImgId);

		// Step 4: 复制图片资源 imgCtrl
		const oldImageItem = imageCtrl.images[imgID];
		imageCtrl.images[newImgId] = $.extend(true, {}, oldImageItem);

		// Step 5: 更新
		imageCtrl.ref();

		return f;
	},

	/**
	 * @description 在canvas上绘制图片
	 */
	drawImageToCanvas(canvas, image, item, offsetLeft, offsetTop) {
		let r = item.r,
			c = item.c,
			start_r = item.start_r,
			start_c = item.start_c,
			end_r = item.end_r,
			end_c = item.end_c;

		// 计算单元格尺寸和图片显示尺寸
		let cellWidth = end_c - start_c - 2;
		let cellHeight = end_r - start_r - 2;
		const w = cellWidth * 0.9;
		const h = cellHeight * 0.9;
		const x = (cellWidth - w) / 2 + start_c + offsetLeft;
		const y = (cellHeight - h) / 2 + start_r + offsetTop;

		// 绘制图片
		canvas.drawImage(image, x, y, w, h);
	},

	/**
	 * @description 绘制占位符（当图片加载失败时）
	 */
	drawPlaceholder(canvas, item, offsetLeft, offsetTop) {
		let r = item.r,
			c = item.c,
			start_r = item.start_r,
			start_c = item.start_c,
			end_r = item.end_r,
			end_c = item.end_c;

		// 计算单元格尺寸
		let cellWidth = end_c - start_c - 2;
		let cellHeight = end_r - start_r - 2;

		// 绘制占位符矩形
		const x = start_c + offsetLeft;
		const y = start_r + offsetTop;

		canvas.save();
		canvas.fillStyle = "#f0f0f0";
		canvas.fillRect(x, y, cellWidth, cellHeight);

		// 绘制占位符边框
		canvas.strokeStyle = "#ccc";
		canvas.lineWidth = 1;
		canvas.strokeRect(x, y, cellWidth, cellHeight);

		// 绘制占位符文本
		canvas.fillStyle = "#999";
		canvas.font = "12px Arial";
		canvas.textAlign = "center";
		canvas.textBaseline = "middle";
		canvas.fillText("图片加载失败", x + cellWidth / 2, y + cellHeight / 2);
		canvas.restore();
	},

	/**
	 * @description 清除图片缓存（可选）
	 */
	clearImageCache: function () {
		this.imageCache = new Set();
	},

	/**
	 * @description 工具函数 获取图片资源 - 可能通过服务器获取，可能是 base64
	 * @param {String} src 图片ID
	 * @returns {String} 图片资源路径
	 */
	getImageSrc: function (src) {
		let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions["imageUrlHandle"];
		return typeof imageUrlHandle === "function" ? imageUrlHandle(src) : src;
	},

	/**
	 * @description 绘制水印
	 * @param {CanvasRenderingContext2D} ctx canvas上下文
	 * @param {Number} width canvas宽度
	 * @param {Number} height canvas高度
	 */
	drawWatermark(ctx, width, height) {
		// 获取水印配置
		const watermarkConfig = {
			text: "pushu", // 水印文本
			font: "bold 20px Arial", // 水印字体
			color: "rgba(0, 0, 0, 0.1)", // 水印颜色
			rotate: -Math.PI / 4, // 水印旋转角度（弧度）
			spacing: 100, // 水印间距
		};

		// 保存画布状态
		ctx.save();

		// 设置水印样式
		ctx.fillStyle = watermarkConfig.color;
		ctx.font = watermarkConfig.font;

		// 获取文本尺寸
		const text = watermarkConfig.text;
		const textWidth = ctx.measureText(text).width;
		const textHeight = 20; // 大致的文本高度

		// 计算对角线长度
		const diagonal = Math.sqrt(width * width + height * height);

		// 计算水印间距
		const watermarkSpacing = watermarkConfig.spacing || Math.max(textWidth, textHeight) * 1.5;

		// 旋转整个画布
		ctx.translate(width / 2, height / 2);
		ctx.rotate(watermarkConfig.rotate || -Math.PI / 4);

		// 简化循环逻辑，直接基于对角线长度计算边界
		const start = -diagonal;
		const end = diagonal;

		// 在旋转后的坐标系中绘制平铺的水印
		for (let x = start; x < end; x += watermarkSpacing) {
			for (let y = start; y < end; y += watermarkSpacing * 0.5) {
				ctx.fillText(text, x, y);
			}
		}

		// 恢复画布状态
		ctx.restore();
	},
};
